export default __webpack_public_path__ + "img/a58c3357aa3941eb0aa6ea259c316195.png";